export default __webpack_public_path__ + "static/media/YTlogo.25ae0241.svg";